/**
 * dir-w | backOffice
 * Application enums
 * - USER ROLE
 * - INTERACTION METHOD
 * - PAGE MODE
 * - PAGE RESULT
 * - PAGINATION
 *
 * Last update : January 10, 2024 | @rizkiprasetya
 */

/**
 * Enum for user role
 */
export enum enumUserRole {
  ADMINISTRATOR = 'administrator',
  CLUB = 'club',
  COACH = 'coach',
  DEVELOPER = 'developer',
  EVENT_ORGANIZER = 'eventOrganizer',
  MUNICIPAL_ASSOCIATION = 'municipalAssociation',
  NATIONAL_ASSOCIATION = 'nationalAssociation',
  PARENT = 'parent',
  PLAYER = 'player',
  PROVINCIAL_ASSOCIATION = 'provincialAssociation',
  PUBLIC = 'public',
  SOCCER_SCHOOL = 'soccerSchool',
}

/**
 * Enum interaction used in service to communicate with API\
 * All function required a single ID (UUID) to perform the operation\
 * Method `READ` are used to retrieve a record\
 * Method `DELETE` are used to delete a record\
 * Method `RESTORE` are used to restore a record
 */
export enum enumInteractionMethod {
  READ = 'read',
  DELETE = 'delete',
  RESTORE = 'restore',
}

/**
 * Enum page mode used in Page Properties component.
 * Mode `LOADING` show loading process
 * Mode `DISPLAY` show process result success / error
 */
export enum enumPageMode {
  LOADING = 'loading',
  DISPLAY = 'display',
}

/**
 * Enum text color for Page Properties result process
 */
export enum enumPageResult {
  SUCCESS = 'success',
  ERROR = 'error',
  NORMAL = 'normal',
}

/**
 * Enum for paging navigation
 */
export enum enumPagination {
  FIRST = 'first',
  LAST = 'last',
  PREVIOUS = 'previous',
  NEXT = 'next',
}

/**
 * Enum to show the overlay mode content
 */
export enum enumOverlayMode {
  LOADING = 'loading',
  DISPLAY = 'display',
}

/**
 * Enum text color for overlay content
 */
export enum enumOverlayTextColor {
  ERROR = 'danger',
  NORMAL = 'white',
  SUCCESS = 'success',
  WARNING = 'warning',
}
